import React from 'react';
import styles from './ViewInvoice.styles.scss';
import { viewObject } from './ViewInvoice.config';
import cn from 'classnames';
import { Button } from '../../../../components/shared/Button';
import { INVOICE_TYPE_LABELS } from '../../../../config/invoice/constants';
import { ViewInput } from './components/ViewInput';
import { ViewSection } from './components/ViewSection';
import { useTranslation } from 'react-i18next';
import { useCustomContext } from '../../../../context/customContext';
import { Header } from '../CreateInvoice/components/Header';

const ViewInvoice = ({ onDownloadPdfClick, invoice, type }) => {
  const { t, i18n } = useTranslation();

  const { countryData } = useCustomContext();

  return (
    <div className={styles.container}>
      <Header />
      <div>
        {invoice &&
          viewObject({
            obj: invoice,
            language: i18n.language,
            cities: countryData?.cities?.[i18n.language],
          }).map((block, blockIdx) =>
            block?.image ? (
              <div className={cn('row', styles.block)} key={block.key}>
                <div className={cn('col-2', styles.logo)}>
                  {block.logo && (
                    <img
                      alt={`${block.key || 'invoice'} logo`}
                      src={block.logo}
                    />
                  )}
                </div>
                <div className="col-4" />
                <div className="col-6">
                  <div className={styles.titleQr}>
                    <p>{INVOICE_TYPE_LABELS(i18n.language)[type]}</p>
                    <img
                      width={'186px'}
                      alt={`${block.key || 'invoice'} preview image`}
                      src={block.image}
                    />
                  </div>
                </div>
                <div className="col-12">
                  {block.sections.map((section) => (
                    <div className="row" key={section.key}>
                      {section.title && (
                        <h4 className={styles.sectionTitle}>
                          {t(section.title)}
                        </h4>
                      )}
                      <div className={cn('row', styles.section)}>
                        {section?.inputs?.map((input, i) => (
                          <ViewInput
                            basicData={true}
                            key={input.label}
                            input={input}
                            index={i}
                            styles={styles}
                            t={t}
                          />
                        ))}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            ) : (
              block && (
                <ViewSection
                  invoice={invoice}
                  block={block}
                  blockIdx={blockIdx}
                  styles={styles}
                  key={block?.key}
                />
              )
            ),
          )}
      </div>
      <div className={styles.buttons}>
        <Button
          id="download_pdf_btn"
          onClick={onDownloadPdfClick}
          className={'col-12 mx-3'}
        >
          {t('download_pdf')}
        </Button>
      </div>
    </div>
  );
};

export default React.memo(ViewInvoice);
